import { render, staticRenderFns } from "./UserLoanPrintHtml2.vue?vue&type=template&id=51b227f3&scoped=true&"
import script from "./UserLoanPrintHtml2.vue?vue&type=script&lang=js&"
export * from "./UserLoanPrintHtml2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b227f3",
  null
  
)

export default component.exports